import React from 'react'
import styled, { css } from 'styled-components'
import { PositionProps, position, layout, LayoutProps } from 'styled-system'

import { colors } from 'utils/colors'

export type ButtonComponentType = React.ReactNode | React.ElementType | string | undefined

type Props = PositionProps &
  LayoutProps & {
    leftButtonComponent?: ButtonComponentType
    rightButtonComponent?: ButtonComponentType
    padding?: string | undefined
    showFooterLine?: boolean
    color?: keyof typeof colors
    borderColor?: keyof typeof colors
    isSticky?: boolean
    isVisible?: boolean
    style?: React.CSSProperties
  }

const Footer = ({
  height = 60,
  leftButtonComponent,
  rightButtonComponent,
  padding,
  showFooterLine = false,
  color = 'white',
  borderColor = 'gray4',
  isSticky = false,
  isVisible = true,
  ...props
}: Props) => {
  if (!isVisible) return null

  return (
    <Container
      height={height}
      padding={padding}
      showFooterLine={showFooterLine}
      color={color}
      borderColor={borderColor}
      flexEnd={!leftButtonComponent || !rightButtonComponent}
      isSticky={isSticky}
      {...props}
    >
      {leftButtonComponent}
      {rightButtonComponent}
    </Container>
  )
}

const Container = styled.div<Props & { flexEnd: boolean }>`
  ${position}
  ${layout}
  align-items: center;
  display: flex;
  padding: ${(p) => p.padding ?? '0 2rem'};
  ${(p) =>
    p.showFooterLine &&
    css`
      border-top: 1px solid ${colors[p.borderColor as keyof typeof colors]};
    `}
  background-color: ${(p) => (p.color ? colors[p.color] : colors.white)};
  justify-content: ${(p) => (p.flexEnd ? 'flex-end' : 'space-between')};
  ${(p) =>
    p.isSticky &&
    `
    box-sizing: border-box;
    position: ${p.position ? p.position : 'absolute'};
    width: 100%;
    bottom: 0;
  `}
`

export default Footer
